import { BookmakersList as BookmakersListComponent } from './BookmakersList.component';
import { connector } from './BookmakersList.connector';

export const BookmakersList = connector(BookmakersListComponent);
